export default {
  PACKAGE_COST_PER_USE: 'packageCostPerUse',
  PACKAGE_TITLE_COST_PER_USE: 'packageTitleCostPerUse',
  TITLE_COST_PER_USE: 'titleCostPerUse',
  RESOURCE_COST_PER_USE: 'resourceCostPerUse',
};
